export default "__VITE_ASSET__423a2afa__"